var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.11,-1.16797 H -1.11328 V 4253.19 H 4253.11 V -1.16797",
    style: {
      fill: "#f9af16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 435.242,3778.97 H 657.941 L 465.578,3038.88 h 143.027 l 188.516,724.91 v 132.88 H 435.242 v -117.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2127.65,1248.96 c -179.09,0 -324.29,145.17 -324.29,324.28 0,145.59 95.84,268.71 227.92,309.76 v -120.75 c -68.76,-35.11 -115.93,-106.47 -115.93,-189.01 0,-117.25 95.01,-212.29 212.3,-212.29 117.28,0 212.29,95.04 212.29,212.29 0,82.78 -47.4,154.26 -116.46,189.29 v 120.62 c 132.34,-40.86 228.51,-164.12 228.51,-309.91 0,-179.11 -145.2,-324.28 -324.34,-324.28 m -46.27,696.69 c 0,20.76 20.84,43.61 46.43,43.61 25.53,0 46.18,-22.85 46.18,-43.61 v -214.07 c 0,-20.65 -20.65,-43.27 -46.18,-43.27 -25.59,0 -46.43,22.62 -46.43,43.27 z m 46.17,246.32 c -344.32,0 -623.46,-279.15 -623.46,-623.5 0,-344.5 279.14,-623.579 623.46,-623.579 344.32,0 623.45,279.079 623.45,623.579 0,344.35 -279.13,623.5 -623.45,623.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1411.82,1573.92 c 0,28.27 -25.04,51.17 -47.91,51.17 h -273.04 c -23.04,0 -48.31,-22.9 -48.31,-51.17 0,-28.35 25.27,-51.38 48.31,-51.38 h 273.04 c 22.87,0 47.91,23.03 47.91,51.38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3212.82,1573.92 c 0,28.27 -25.05,51.17 -47.92,51.17 h -273.04 c -23,0 -48.28,-22.9 -48.28,-51.17 0,-28.35 25.28,-51.38 48.28,-51.38 h 273.04 c 22.87,0 47.92,23.03 47.92,51.38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2127.81,2289.69 c 28.21,0 51.14,25.05 51.14,47.89 v 273.07 c 0,23.03 -22.93,48.28 -51.14,48.28 -28.32,0 -51.41,-25.25 -51.41,-48.28 v -273.07 c 0,-22.84 23.09,-47.89 51.41,-47.89",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2127.81,488.73 c 28.21,0 51.14,25.04 51.14,47.911 v 273.007 c 0,23.012 -22.93,48.313 -51.14,48.313 -28.32,0 -51.41,-25.301 -51.41,-48.313 V 536.641 c 0,-22.871 23.09,-47.911 51.41,-47.911",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1506.42,1929.49 c 14.07,24.55 3.71,56.85 -16.16,68.21 l -236.98,135.62 c -19.98,11.46 -53.28,4.13 -67.33,-20.4 -14.07,-24.6 -3.56,-57.13 16.42,-68.59 l 236.97,-135.62 c 19.83,-11.36 53.01,-3.82 67.08,20.78",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3069.53,1034.91 c 14.02,24.5 3.67,56.85 -16.16,68.21 l -236.97,135.62 c -19.99,11.43 -53.32,4.1 -67.33,-20.45 -14.08,-24.55 -3.59,-57.14 16.39,-68.55 l 236.97,-135.61 c 19.86,-11.37 53,-3.82 67.1,20.78",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2483.38,2195.07 c 24.53,-14.02 56.8,-3.66 68.19,16.17 l 135.62,236.97 c 11.46,20.01 4.12,53.31 -20.4,67.36 -24.58,14.09 -57.16,3.56 -68.6,-16.42 L 2462.58,2262.2 c -11.37,-19.88 -3.83,-53.06 20.8,-67.13",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1588.8,631.98 c 24.5,-14.019 56.82,-3.66 68.18,16.192 l 135.62,236.949 c 11.44,19.981 4.1,53.34 -20.42,67.359 -24.56,14.059 -57.16,3.559 -68.57,-16.402 L 1567.99,699.109 c -11.36,-19.828 -3.79,-53.058 20.81,-67.129",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1770.91,2194.45 c 24.5,14.1 31.89,47.22 20.47,67.05 l -136.1,236.71 c -11.52,19.96 -43.91,30.42 -68.44,16.32 -24.61,-14.1 -31.94,-47.5 -20.43,-67.46 l 136.09,-236.66 c 11.43,-19.83 43.81,-30.08 68.41,-15.96",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2668.7,633.191 c 24.5,14.098 31.88,47.231 20.5,67.028 L 2553.09,936.93 c -11.51,19.961 -43.94,30.441 -68.47,16.351 -24.57,-14.101 -31.94,-47.511 -20.39,-67.492 l 136.08,-236.687 c 11.38,-19.801 43.81,-30.02 68.39,-15.911",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2748.34,1930.6 c 14.07,-24.47 47.19,-31.85 67.02,-20.47 l 236.67,136.11 c 19.98,11.48 30.51,43.94 16.42,68.44 -14.15,24.55 -47.5,31.94 -67.49,20.45 l -236.69,-136.11 c -19.82,-11.39 -30.07,-43.86 -15.93,-68.42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1187.09,1032.79 c 14.07,-24.47 47.19,-31.86 67.01,-20.45 l 236.67,136.11 c 19.98,11.47 30.52,43.92 16.37,68.42 -14.07,24.58 -47.5,31.93 -67.43,20.47 l -236.69,-136.11 c -19.83,-11.38 -30.05,-43.86 -15.93,-68.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1268.6,3698.02 v -112.35 h 26.5 c 20.14,0 29.67,10.07 29.67,29.15 v 54.05 c 0,19.08 -9.01,29.15 -30.2,29.15 z m 0,46.1 h 21.2 c 19.61,0 28.62,10.07 28.62,29.15 v 43.99 c 0,19.6 -9.01,29.14 -29.15,29.14 h -20.67 z m -60.41,151.56 h 87.44 c 60.41,0 80.55,-28.08 80.55,-78.96 v -36.56 c 0,-30.21 -11.13,-49.28 -36.04,-57.23 30.21,-6.89 45.05,-27.03 45.05,-59.89 v -47.69 c 0,-50.88 -22.79,-78.96 -83.2,-78.96 h -93.8 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1412.76,3895.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1645.42,3585.67 h 91.68 v -49.28 h -154.74 v 49.28 l 94.86,260.73 h -85.32 v 49.28 h 148.91 v -49.28 l -95.39,-260.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1833.58,3650.32 h 48.22 l -23.85,144.15 h -0.53 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2103.87,3694.84 h -58.3 v -158.45 h -60.41 v 359.29 h 60.41 v -152.09 h 58.3 v 152.09 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2196.62,3895.68 h 60.42 v -310.01 h 72.07 v -49.28 h -132.49 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2414.45,3698.02 v -112.35 h 26.49 c 20.14,0 29.68,10.07 29.68,29.15 v 54.05 c 0,19.08 -9.01,29.15 -30.21,29.15 z m 0,46.1 h 21.19 c 19.61,0 28.62,10.07 28.62,29.15 v 43.99 c 0,19.6 -9.01,29.14 -29.14,29.14 h -20.67 z m -60.42,151.56 h 87.44 c 60.41,0 80.55,-28.08 80.55,-78.96 v -36.56 c 0,-30.21 -11.12,-49.28 -36.03,-57.23 30.2,-6.89 45.04,-27.03 45.04,-59.89 v -47.69 c 0,-50.88 -22.78,-78.96 -83.2,-78.96 h -93.8 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2622.21,3650.32 h 48.22 l -23.85,144.15 h -0.52 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2834.21,3846.4 v -111.81 h 20.13 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2975.19,3895.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.89 v -48.75 h -59.89 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3377.43,3895.68 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 3618 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3460.12,3762.14 v -225.75 h -50.87 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -52.99 l -71.02,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3701.8,3585.67 c 24.91,0 34.45,14.84 34.45,36.56 v 188.14 c 0,21.19 -9.54,36.03 -34.45,36.03 h -25.43 v -260.73 z m 94.86,213.57 v -166.4 c 0,-55.12 -22.79,-96.45 -87.44,-96.45 h -93.27 v 359.29 h 93.27 c 64.65,0 87.44,-40.8 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1205.01,3113.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.07,0 27.56,12.72 27.56,31.8 v 13.77 c 0,20.67 -8.49,33.39 -27.03,50.88 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.16 h -55.11 v 31.27 c 0,20.67 -9.55,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1468.41,3150.32 h 48.22 l -23.84,144.15 h -0.53 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1787.45,3395.68 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 3118 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1879.69,3198.02 v -112.35 h 26.49 c 20.14,0 29.68,10.07 29.68,29.15 v 54.05 c 0,19.08 -9.01,29.15 -30.21,29.15 z m 0,46.1 h 21.19 c 19.61,0 28.62,10.07 28.62,29.15 v 43.99 c 0,19.6 -9.01,29.14 -29.15,29.14 h -20.66 z m -60.42,151.56 h 87.44 c 60.42,0 80.55,-28.08 80.55,-78.96 v -36.56 c 0,-30.21 -11.12,-49.29 -36.03,-57.24 30.2,-6.88 45.04,-27.02 45.04,-59.88 v -47.69 c 0,-50.88 -22.79,-78.96 -83.2,-78.96 h -93.8 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2023.85,3395.68 H 2168 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 V 3085.67 H 2168 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2258.1,3346.4 v -111.82 h 20.14 c 20.66,0 29.67,10.6 29.67,29.68 v 53 c 0,19.6 -9.01,29.14 -29.67,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.21,-30.2 83.21,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.23,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2399.08,3395.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2625.92,3395.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2850.63,3262.14 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3006.45,3395.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.89 v -48.75 h -59.89 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3240.7,3346.4 v -111.82 h 20.14 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.96 c 60.95,0 83.21,-30.2 83.21,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.75,-163.22 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3472.83,3228.22 h 85.85 v -191.83 h -43.45 v 39.21 c -7.95,-27.03 -24.91,-43.45 -57.77,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.82 c 0,56.17 27.03,96.97 90.62,96.97 66.78,0 86.38,-37.09 86.38,-90.08 v -31.8 h -55.11 v 36.57 c 0,22.25 -8.48,34.97 -30.21,34.97 -21.73,0 -31.26,-15.37 -31.26,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.6,0 29.67,11.13 29.67,34.45 v 63.59 h -28.62 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3590.5,3395.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3683.24,3395.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe07);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-07.c2e03651efc9619a2c90002c9374f359.svg";
export { ForwardRef as ReactComponent };